import { MyTypo } from "../../utils/typography/typographier";

function CardMobile2({ athletes1, athletes2 }) {
  return (
    <div className="cardSecondary">
      <div className="cardSecondary-containers1">
        <div className="cardSecondary-containers1-title">
          <h2>{athletes1.title}</h2>
        </div>
        <div className="cardSecondary-containers1-subtitle">
          <p>{MyTypo(athletes1.subtitle1)}</p>
        </div>
        <div className="cardSecondary-containers1-subtitle">
          <p>{MyTypo(athletes1.subtitle2)}</p>
        </div>
      </div>
      <div className="cardSecondary-containers2">
        <div className="cardSecondary-containers2-athlete">
          <div className="cardSecondary-containers2-athlete-container">
            <div className="cardSecondary-containers2-athlete-container-img1">
              <img src={athletes1.cover} alt={athletes1.alt} />
            </div>
          </div>
          <div className="cardSecondary-containers2-athlete-container1">
            <div className="cardSecondary-containers2-athlete-container1-title">
              <p>{athletes1.title2}</p>
            </div>
            <div className="cardSecondary-containers2-athlete-container1-subtitle">
              <p>{athletes1.title3}</p>
            </div>
            <div className="cardSecondary-containers2-athlete-container1-descriptionLast">
              <p>{athletes1.description1}</p>
            </div>
          </div>
        </div>
        <div className="cardSecondary-containers2-athlete">
          <div className="cardSecondary-containers2-athlete-container">
            <div className="cardSecondary-containers2-athlete-container-img2">
              <img src={athletes2.cover} alt={athletes2.alt} />
            </div>
          </div>
          <div className="cardSecondary-containers2-athlete-container1">
            <div className="cardSecondary-containers2-athlete-container1-title">
              <p>{athletes2.title2}</p>
            </div>
            <div className="cardSecondary-containers2-athlete-container1-description">
              <p>{athletes2.description1}</p>
            </div>
            <div className="cardSecondary-containers2-athlete-container1-descriptionLast">
              <p>{athletes2.description2}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardMobile2;
